import React from 'react';

export const PageNotFound = () => {
    return <h1>Page Not Found</h1>;
};